import * as React from 'react';
import 'leaflet/dist/leaflet.css';

import "./neighborhood-map-control.scss";

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {keyed}     from "@Common/react/keyed";
import {UseState}  from "@Common/react/use-state";
import {Watch}     from '@Common/react/watch';
import {equalDeep} from '@Common/utils/objects';

import {LeafletMap} from "../../../../common/leaflet-map/leaflet-map";
import {cx}         from 'emotion';

export const NeighborhoodMapControl = ({center, shapes=undefined, postOffices=undefined, hoveredShape, viewSize}) => cs(
    ["cursorPosition", (_, next) => UseState({
        next,
    })],
    ["leafletMap", ({cursorPosition}, next) => LeafletMap({
        center,
        onMouseMove: (e) => cursorPosition.onChange({pos: getELoc(e.originalEvent), latlng: e.latlng}),
        xdQaPrefix: "Neighborhood Search",
        next,
    })],
    ({leafletMap, cursorPosition}) => fragments(
        (
            <div className="neighborhood-map-71o">
                <div className={cx("map", viewSize)} ref={leafletMap.ref}/>

                {hoveredShape.value && cursorPosition.value && (
                    InfoBox({
                        hoveredShape: hoveredShape.value,
                        position: cursorPosition.value,
                    })
                )}
            </div>
        ),
        shapes?.map((shape) => cs(
            keyed(shape.elementKey),
            () => (
                leafletMap.renderPolygon({
                    shape,
                    onClick: shape.onClick,
                    onMouseOver: shape.onMouseOver,
                    onMouseOut : shape.onMouseOut,
                })
            )
        )),
        // Add post office feature once PO Box routes properly report lat/lng of Post Office
        // postOffices?.map((office) => cs(
        //     keyed(office.elementKey),
        //     () => (
        //         leafletMap.renderMarker({
        //             office,
        //             onClick: office.onClick,
        //             onMouseOver: office.onMouseOver,
        //             onMouseOut: office.onMouseOut,
        //         })
        //     )
        // // )),
        Watch({
            value: shapes,
            compare: (s1, s2) => equalDeep(s1?.map(s => s.elementKey), s2?.map(s => s.elementKey)),
            onChanged: () => {
                leafletMap.cleanMap({
                    elements: shapes
                })
            },
        }),
        Watch({
            value: viewSize,
            onChanged: () => leafletMap.invalidateSize(),
        })
    )
);

const getELoc = (e) => {
    let x = e.clientX;
    let y = e.clientY;

    return {x, y};
};

const InfoBox = ({hoveredShape, position}) => {
    return (
        <div className="info-box" style={{ top: position.pos.y - 60, left: position.pos.x - 150 }}>
            {hoveredShape.type === "polygon" ? (
                <>
                    <div className="box route">
                        <div
                            className="value"
                            xd-qa-name="Neighborhood Search Hovered Route Name"
                            xd-qa-type="label"
                        >{hoveredShape.name}</div>
                        <div
                            className="label"
                            xd-qa-name="Neighborhood Search Hovered Route"
                            xd-qa-type="label"
                        >Neighborhood</div>
                    </div>
                    <div className="box records">
                        <div
                            className="value"
                            xd-qa-name="Neighborhood Search Hovered Route Records Count"
                            xd-qa-type="label"
                        >{hoveredShape.count}</div>
                        <div
                            className="label"
                            xd-qa-name="Neighborhood Search Hovered Route Records"
                            xd-qa-type="label"
                        >Records</div>
                    </div>
                    <div className={
                        cx("box", {
                            low: hoveredShape.match_rate<30 || hoveredShape.match_rate === undefined,
                            mid: hoveredShape.match_rate<70 && hoveredShape.match_rate>=30,
                            high: hoveredShape.match_rate>70
                        })
                    }>
                            <div
                                className="value"
                                xd-qa-name="Neighborhood Search Hovered Route Match Rate"
                                xd-qa-type="label"
                            >
                                {hoveredShape.match_rate !== undefined ? hoveredShape.match_rate + "%" : "--"}
                            </div>
                            <div
                                className="label"
                                xd-qa-name="Neighborhood Search Hovered Route Match Rate Label"
                                xd-qa-type="label"
                            >Match Score</div>
                    </div>
                </>
            ) : (
                <div className="box msg">
                    Manage PO Box Neighborhood Routes
                </div>
            )}
        </div>
    )
};